import { useState } from 'react'
import { UseFormRegister, FieldErrors } from 'react-hook-form'
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import globalStyles from '../../../../styles/input.module.css'
import { t } from 'i18next'

type PasswordFormData = {
  password?: string
  oldPassword?: string
  newPassword?: string
  confirmPassword?: string
}

interface PasswordInputProps {
  register: UseFormRegister<PasswordFormData>
  errors: FieldErrors<PasswordFormData>
  name: keyof PasswordFormData
  label?: string
}

const PasswordInput = ({
  register,
  errors,
  name,
  label = 'Password',
}: PasswordInputProps) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)

  return (
    <div className={globalStyles.inputGroup}>
      <label htmlFor={name}>{label} *</label>
      <div className={globalStyles.inputContainer}>
        <input
          {...register(name, { required: true })}
          type={isPasswordVisible ? 'text' : 'password'}
        />
        <div
          onClick={() => setIsPasswordVisible(!isPasswordVisible)}
          className={globalStyles.passwordVisibilityIcon}
        >
          {isPasswordVisible ? (
            <VisibilityOutlinedIcon />
          ) : (
            <VisibilityOffOutlinedIcon />
          )}
        </div>
      </div>

      {errors[name] && <span>{t('signup.required')}</span>}
    </div>
  )
}

export default PasswordInput
